module.exports = __webpack_public_path__ + "static/img/enterprise_plan_icon.a99e54b7.svg";